import { User, onAuthStateChanged } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { setLogLevel } from 'firebase/firestore';

import config from '../../envConfig';

const firebaseConfig = {
  apiKey: config.firebaseApiKey,
  authDomain: config.firebaseAuthDomain,
  projectId: config.firebaseProjectId,
  storageBucket: config.firebaseStorageBucket,
  messagingSenderId: config.firebaseMessagingSenderId,
  appId: config.firebaseAppId,
  measurementId: config.firebaseMeasurementId,
};

let logLevelInitialized = false;

const ensureFirebaseInitialized = (): void => {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }

  if (!logLevelInitialized) {
    setLogLevel('silent');
    logLevelInitialized = true;
  }
};
ensureFirebaseInitialized();

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const appleProvider = new firebase.auth.OAuthProvider('apple.com');
export const facebookProvider = new firebase.auth.FacebookAuthProvider();

export const waitForAuthInit = (): Promise<User | null> => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};
